import { formatDisplayDateTime } from "utils/dateFormat";

export function getCurrentUserDisplayName() {
  try {
    const detail = JSON.parse(localStorage.getItem("userDetail") || "null");
    const name = detail?.name?.trim();
    if (name) return name;
    const email = detail?.email?.trim();
    return email || null;
  } catch {
    return null;
  }
}

export function buildFlowDocument({ name, url, id }) {
  return {
    id: id || crypto.randomUUID(),
    name,
    url,
    addedAt: new Date().toISOString(),
    addedBy: getCurrentUserDisplayName(),
  };
}

export function formatDocumentMeta(doc) {
  if (!doc) return "—";
  const parts = [];
  const at = doc.addedAt || doc.uploadedAt;
  if (at) {
    try {
      parts.push(formatDisplayDateTime(at));
    } catch {
      // ignore invalid dates
    }
  }
  const by = doc.addedBy || doc.uploadedBy;
  if (by) {
    parts.push(by);
  }
  return parts.length > 0 ? parts.join(" · ") : "—";
}
